
import React from "react";
import { Row, Col, Typography } from "antd";

const StatSummary = ({ statistics }) => {
  const renderStatGroup = (type, color, title) => (
    <div style={{ 
      border: '1px solid #e8e8e8', 
      borderRadius: 4,
      padding: '6px 8px',
      backgroundColor: '#fdfdfd'
    }}>
      <div style={{ 
        fontSize: 12, 
        fontWeight: 600, 
        color: color,
        marginBottom: 4,
       }}>
        {title}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {Object.keys(statistics).map((key) => (
          <div key={`${key}-${type}`} style={{ 
            display: "flex", 
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <span style={{ 
              fontSize: 11, 
              color: '#666',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '50%'
            }}>
              {key.replace(/_/g, ' ')}
            </span>
            <span style={{ 
              color, 
              fontWeight: 600, 
              fontSize: 12
            }}>
              {statistics[key][type].toFixed(2)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Row gutter={6} style={{ marginBottom: 8 }}>
      <Col span={6}>
        {renderStatGroup("average", "#52c41a", "Avg")}
      </Col>
      <Col span={6}>
        {renderStatGroup("max", "#faad14", "Peak")}
      </Col>
      <Col span={6}>
        {renderStatGroup("total", "#1890ff", "Total")}
      </Col>
      <Col span={6}>
        {renderStatGroup("min", "#f5222d", "Min")}
      </Col>
    </Row>
  );
};

export default StatSummary